import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Element } from '../../../../common/html/element'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { COMPONENTS } from '../../../../routers/constants'
import { EMPTY_VALUE } from '../../../../utils/common'
import { selectTopComparablePlayersById } from '../../store/slice'
import { getLocalizedValue } from './helper'

export const Company = ({ rowId, isDynamicReport }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const data = useSelector(selectTopComparablePlayersById(rowId))
  const isRedirect =
    !isDynamicReport && data?.allowRedirectLink && data?.similarOrganizationId
  const Wrapper = isRedirect ? Link : Element
  const companyName =
    getLocalizedValue(data, 'similarOrganizationName', locale) || EMPTY_VALUE

  if (isDynamicReport) {
    return <Element style={{ overflowWrap: 'anywhere' }}>{companyName}</Element>
  }

  return (
    <Element
      style={{
        color: isRedirect ? '#2C73E8' : 'inherit',
        cursor: isRedirect ? 'pointer' : 'default',
      }}
    >
      <Wrapper
        to={
          isRedirect
            ? `${COMPONENTS.companyAnalysis.components.summary.route}?organizationId=${data.similarOrganizationId}&showDetail=true`
            : undefined
        }
        target={isRedirect ? '_blank' : undefined}
        rel={isRedirect ? 'noopener noreferrer' : undefined}
      >
        <TextEllipsisStaticLine
          text={companyName}
          isI18n={false}
          lineClamp={1}
        />
      </Wrapper>
    </Element>
  )
}

Company.propTypes = {
  rowId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  isDynamicReport: PropTypes.bool,
}

Company.defaultProps = {
  isDynamicReport: false,
}
